module.exports = __webpack_public_path__ + "img/52.a060e0b7.jpg";